module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-gebaeudetechnik-eddc31b1d52aff57572b465285b4d9a0.svg";